import React from "react";
import Header from "../../headerone/Main";
import Bredcom from "../../Bredcom/Main";
import GaneshaVisarjana from "../../Blogdetails/GaneshaVisarjana";

function Main() {
  return (
    <>
      <section className="hide-overflow">
        <Header />
        <Bredcom title="Home" subtitle="Ganesha Visarjana 2026" />
        <GaneshaVisarjana />
      </section>
    </>
  );
}

export default Main;
